import form from './form';
import { FilterCheckbox, FilterSelectMasterInfo } from './form';

const Form = form;
Form.SelectMasterInfo = FilterSelectMasterInfo;
Form.CheckboxFilter = FilterCheckbox;

export default Form;
